﻿import React, { useEffect, useState } from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { IFrameCommManager } from "../../Managers";
import { ViewShare } from "../../ViewShare/ViewShare";

type ListeningState = "Listening" | "NotListening";

export const ViewShareSection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => {
    const [isEnabled, setIsEnabled] = useState<boolean>(true),
        [messageListeningState, setMessageListeningState] =
            useState<ListeningState>(`Listening`);

    const key = `ViewShareSection`;

    useEffect(() => {
        IFrameCommManager.registerOrUpdateResetState(resetViewShare);

        return (): void => {
            IFrameCommManager.deRegisterResetState();
        };
    }, []);

    const resetViewShare = (): void => {
        setMessageListeningState(`Listening`);
        setIsEnabled(false);
    };

    const bindOnClick = (): void => {
        if (isEnabled) {
            const viewshareComponent: React.ReactNode = <ViewShare />;

            const activeProps: IActiveSectionProps = {
                moduleID: props.moduleID,
                sectionType: props.sectionType,
                subWindow: {
                    body: viewshareComponent,
                    isDominant: false,
                    moduleID: props.moduleID,
                    subWindowKey: `viewshareWindow`,
                    title: `View Share`,
                },
            };

            props.toggleSection(activeProps, activeSectionsComparer);
        }
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            if (activeSections[i].sectionType === `ViewShare`) {
                activeSections.splice(i, 1);
                i--;
            }
        }
        return activeSections;
    };

    const onMessageReceived = (moduleId: number, message: string): void => {
        if (messageListeningState === `Listening`) {
            if (message) {
                switch (message) {
                    case `Initialise`:
                        setIsEnabled(true);
                        setMessageListeningState(`NotListening`);
                        break;
                    default:
                        break;
                }
            }
        }
    };

    // Setup the channel for the viewshare messages.
    IFrameCommManager.registerOrUpdateWatcher(key, onMessageReceived);

    const isActiveCSS: string = props.isActive ? `selected` : ``,
        isEnabledCSS: string = isEnabled ? `` : `disabled`;

    return (
        <div
            className={`tab-section ${isActiveCSS} ${isEnabledCSS}`}
            onClick={bindOnClick}
        >
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </div>
    );
};
